import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { dataTableParamsBuilder } from "../../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../../utils/hooks/use-pagination-query";
import { http } from "../../../utils/http";

function fetchVideoList(params) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/video", baseUrl);

  if (params.title) {
    endpointUrl.searchParams.append("title", params.title);
  }
  if (params.contents) {
    endpointUrl.searchParams.append("contents", params.contents);
  }
  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }
  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }

  if (params.status) {
    endpointUrl.searchParams.append("status", params.status);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useVideoList(params = {}) {
  return usePaginationQuery(
    [
      "video",
      params.title,
      params.contents,
      params.from,
      params.to,
      params.status,
    ],
    (paginationState) => fetchVideoList({ ...params, ...paginationState })
  );
}
async function addVideo(formData) {
  const data = await http(`/admin/video`, {
    data: formData,
  });
  return data;
}

export function useAddVideo() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(addVideo, {
    onSuccess: () => {
      queryClient.refetchQueries(["video"]);
      setTimeout(() => {
        navigate(`/bulletin-board`);
      }, 1500);
    },
  });
}

export function useUpdateVideo(id) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(
    async (data) => {
      const { id, ...payload } = data;
      const res = await http(`/admin/video/${id}`, {
        method: "PUT",
        data: payload,
      });
      return res;
    },
    {
      onSuccess: async (res) => {
        const id = res?.data?.data?.id;
        await queryClient.invalidateQueries(["video-detail"]);
        setTimeout(() => {
          navigate(`/bulletin-board/video/${id}`);
        }, 1500);
      },
    }
  );
}

async function deletevideoById(id) {
  const data = await http(`/admin/video/${id}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeleteVideoById() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(deletevideoById, {
    onSuccess: () => {
      queryClient.invalidateQueries(["video"]);
      setTimeout(() => {
        navigate("/bulletin-board");
      }, 1500);
    },
  });
}

export async function fetchVideoDownload() {
  const { data } = await http(`/admin/video-download`, {
    responseType: "blob",
  });

  return data;
}

export function useVideoDownload() {
  const { data, ...raResult } = useQuery(["video-download"], () =>
    fetchVideoDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}

async function addVideoIntro(formData) {
  const data = await http(`/admin/video/intro`, {
    data: formData,
  });
  return data;
}

export function useAddVideoIntro() {
  const queryClient = useQueryClient();

  return useMutation(addVideoIntro, {
    onSuccess: () => {
      queryClient.refetchQueries(["video-intro"]);
    },
  });
}
